import * as React from "react"
import { storyblokEditable, StoryblokComponent } from "gatsby-source-storyblok"

const LuxuryVaction = ({ blok }) => {
  // console.log(blok)
  return (
    <main {...storyblokEditable(blok)}>
      <div className="relative bg-cover bg-center text-white" style={{ 'backgroundImage': `url(${blok.bannerImage?.filename}/m/)` }}>
        <div className="bg-black bg-opacity-30">
          <div className="container mx-auto p-4">
            <nav className="text-center pt-32 pb-10">
              <a href={`/`} className="hover:text-gray-300 border-b-2">Home</a>
            </nav>
            <div className="text-center pb-40">
              <h1 className="text-4xl font-bold font-serif">{blok.title}</h1>
              <p className="text-lg pt-10 max-w-[700px] mx-auto">{blok.subTitle}</p>
            </div>
          </div>
          {/* <div className="border-t">
            <div className="grid grid-cols-4 lg:max-w-[1000px] container mx-auto text-center">
              <a href="#overview" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Why Amnet?</a>
              <a href="#tours" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Tour Packages</a>
              <a href="#accommodations" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Accommodations</a>
              <a href="#season" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Season's Splendor</a>
            </div>
          </div> */}
        </div>
      </div>

      <div className="sticky top-0 border-t border-b bg-bottom text-white z-[9]" style={{ 'backgroundImage': `url(${blok.bannerImage?.filename})` }}>
        <div className="backdrop-blur-sm">
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:max-w-[1000px] container mx-auto text-center">
            <a href="#overview" className="lg:text-lg py-3 border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">Why Amnet?</a>
            <a href="#tours" className="lg:text-lg py-3 border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">Tour Packages</a>
            <a href="#accommodations" className="lg:text-lg py-3 border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">Accommodations</a>
            <a href="#season" className="lg:text-lg py-3 border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">Season's Splendor</a>
          </div>
        </div>
      </div>
      
      {blok.body?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}

    </main>
  )
};

export default LuxuryVaction;
